/**
 * @ngdoc service
 * @name smartSelectService
 * @module flowingly.components
 *
 * @description A service responsible solely for smart select component
 */

import { SharedAngular } from '@Angular.Runner/@types/sharedAngular';
import IGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/group/groupDetail';
import { IAvailableStepApproverResult } from '@Shared.Angular/@types/core/contracts/queryModel/flows/availableStepApprover';
import { IUserBasicInfoPaginationModel } from '@Shared.Angular/@types/core/contracts/queryModel/user/UserBasicInfoPaginationModel';
import { Guid } from '@Shared.Angular/@types/guid';
import { IHttpService } from 'angular';

angular
  .module('flowingly.components')
  .factory('smartSelectService', smartSelectService);

smartSelectService.$inject = ['$http', 'APP_CONFIG', 'flowinglyConstants'];

function smartSelectService(
  $http: IHttpService,
  APP_CONFIG: SharedAngular.APP_CONFIG,
  flowinglyConstants
) {
  let hasMoreResults = false;

  function getUsers(searchTerm: string, permissionSecureCodes: string[]) {
    return $http.get<IUserBasicInfoPaginationModel>(
      APP_CONFIG.apiBaseUrl +
        `users/searchuser?maxNumberOfUsersToShow=${
          flowinglyConstants.maxNumberOfUsersToShow
        }${searchTerm ? '&searchTerm=' + searchTerm : ''}${
          permissionSecureCodes?.length > 0
            ? '&permissionSecureCodes=' + permissionSecureCodes
            : ''
        }`
    );
  }

  function getGroups() {
    return $http.get<IGroupDetail[]>(
      APP_CONFIG.apiBaseUrl + 'teams?includeDetails=false'
    );
  }

  function getAvailableApprovers(
    nodeId: Guid,
    searchTerm?: string,
    noSpinner = false
  ) {
    return $http.get<IResponseData<IAvailableStepApproverResult>>(
      `${
        APP_CONFIG.apiBaseUrl
      }flows/${nodeId}/availableStepApprovers?maxNumberOfUsersToShow=${
        flowinglyConstants.maxNumberOfUsersToShow
      }${searchTerm ? '&searchTerm=' + searchTerm : ''}`,
      { noSpinner }
    );
  }

  function getHasMoreResults() {
    return hasMoreResults;
  }

  function setHasMoreResults(val) {
    hasMoreResults = val;
  }
  const service = {
    getUsers: getUsers,
    getGroups: getGroups,
    getAvailableApprovers: getAvailableApprovers,
    getHasMoreResults: getHasMoreResults,
    setHasMoreResults: setHasMoreResults
  };

  return service;
}

export type SmartSelectServiceType = ReturnType<typeof smartSelectService>;
